export default __webpack_public_path__ + "static/media/family.3d55a2d6.svg";